import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { InstitutionService } from '../../shared/services/institution.service';
import { LevelOfMembershipService } from '../../shared/services/levelofmebership.service';
declare global {
  interface Window {
    Razorpay: any;
  }
}
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'ps-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss']
})
export class RegisterFormComponent implements OnInit {
  public registerForm!: FormGroup;
  public institutionType: any;
  public selectedlevelofmembership: any;
  public isregisterFormSubmitted: boolean = false;
  public level: any = [];
  public arr: any = [];
  public showAmount: boolean = false;
  public year: any;
  public verify: any;
  public error: any;
  public dropdowns!: { buttonColor: string; arr: any; }[];
  public levelValue: any = [];
  public levelId: any = [];
  public lang: any = [];
  public options = {
    "key": environment.keyId,
    "amount": "",
    "currency": "INR",
    "order_id": "",
    "description": "ELTAI",
    "handler": (response: any) => {
      this.verify = response;
      var event = new CustomEvent("payment.success", {
        detail: response,
        bubbles: true,
        cancelable: true,
      });
      if (event.type == "payment.success") {
        this.router.navigate(["/auth/login"]);
        this.toastr.success("Institution Register Sucessfully");
      }
      window.dispatchEvent(event);
    },
    "prefill": {
      "name": "",
      "email": "",
      "contact": ""
    }
  };
  public instituteProfilePic: any;
  disablePay: boolean = false;
  institutionId: any;
  public language: any = [];

  constructor(private fb: FormBuilder, private toastr: ToastrService, private router: Router, private institutionService: InstitutionService, private levelofmembershipService: LevelOfMembershipService) { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
    this.initializeRegistrationForm();
    this.getAllLevelOfMembership();
    this.getAllLanguages();
  }


  //initializeRegisterForm
  initializeRegistrationForm() {
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      levelOfMembership: ['', Validators.required],
      tertiaryLanguage: [{ value: [], disabled: true }],
      highSchoolLanguage: [{ value: [], disabled: true }],
      primaryLanguage: [{ value: [], disabled: true }],
      email: ['', Validators.required],
      amount: ['', { disabled: true }],
      mobileNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      landlineNumber: [''],
      role: [''],
      address: ['', Validators.required],
      city_Town: ['', Validators.required],
      state: ['', Validators.required],
      pincode: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
      country: ['', Validators.required],
      installment: [false],
      installmentAmount: [''],
      imageUrl: ['']
    });
  }

  //getAllLevelofmembership
  getAllLevelOfMembership() {
    this.levelofmembershipService.getAllLevelOfMembership().subscribe(res => {
      if (res.status) {
        this.institutionType = res.data
        this.institutionType.forEach((element: any) => {
          this.level.push({
            value: element._id,
            label: element.level
          })
        })
        this.arr = this.level
        this.dropdowns = [
          {
            buttonColor: "primary",
            arr: this.arr
          }]
      }
    })
  }

  //on change event upload Cover image
  onChangeImage(files: any) {
    if (files.length === 0) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      var image = new Image();
      image.src = URL.createObjectURL(files[0]);
      image.onload = () => {
        URL.revokeObjectURL(image.src);
        this.instituteProfilePic = reader.result;
      }
    }
  }

  //Function to change level of membership amount and enable /disable language dropdown 
  levelofmembershipChanged(event: any[]) {
    this.selectedlevelofmembership = event;
    let totalAmount = 0;
    this.institutionType.forEach((element: any) => {
      this.selectedlevelofmembership.forEach((data: any) => {
        if (element._id === data.value) {
          totalAmount += parseInt(element.amount, 10);
        }
      });
    });

    if (this.selectedlevelofmembership.length === 0) {
      this.registerForm.patchValue({
        amount: '',
        installment: false
      });
      this.showAmount = false;
    } else {
      this.registerForm.patchValue({
        amount: totalAmount,
        installment: false
      });
      this.showAmount = false;
    }
    const primary = this.registerForm.get('primaryLanguage');
    const tertiary = this.registerForm.get('tertiaryLanguage');
    const highSchool = this.registerForm.get('highSchoolLanguage');
    const selectedLabels = this.selectedlevelofmembership.map((e: any) => e.label);
    if (selectedLabels.includes('Primary')) {
      primary?.enable();
      primary?.setValidators([Validators.required]);
    } else {
      primary?.reset();
      primary?.disable();
      primary?.clearValidators();
    }
    if (selectedLabels.includes('Tertiary')) {
      tertiary?.enable();
      tertiary?.setValidators([Validators.required]);
    } else {
      tertiary?.reset();
      tertiary?.disable();
      tertiary?.clearValidators();
    }
    if (selectedLabels.includes('High School')) {
      highSchool?.enable();
      highSchool?.setValidators([Validators.required]);
    } else {
      highSchool?.reset();
      highSchool?.disable();
      highSchool?.clearValidators();
    }
    [primary, tertiary, highSchool].forEach(ctrl => ctrl?.updateValueAndValidity());
  }

  //installment Checked patch installment Amount
  installmentchecked(event: any) {
    if (event.target.checked) {
      this.showAmount = true
      var totalamountvalue = this.registerForm.value.amount / 2
      this.registerForm.patchValue({
        installment: true,
        installmentAmount: totalamountvalue
      })
    }
    else {
      this.showAmount = false
    }
  }

  //payNow call
  payNow() {
    this.isregisterFormSubmitted = true;
    var data1 = this.registerForm.value;
    this.levelValue = this.registerForm.value.levelOfMembership
    this.levelValue.forEach((element: any) => {
      this.levelId.push({
        _id: element.value,
        level: element.label
      })
    });
    data1.imageUrl = this.instituteProfilePic
    data1.levelOfMembership = this.levelId
    data1.role = "PORTAL_INSTITUTION"
    if (this.registerForm.valid) {
      this.disablePay = true
      this.institutionService.saveinstitutionFormandCreateOrder(data1).subscribe(
        data => {
          if (data.status) {
            this.options.order_id = data.value.orderid;
            this.options.amount = data.value.amount; //paise
            this.institutionId = data.value._id
            this.options.prefill.name = 'Prefilled Name';
            this.options.prefill.email = 'a@a.com';
            this.options.prefill.contact = '1111111111';
            var rzp1 = new window.Razorpay(this.options);
            rzp1.on('payment.failed', (response: any) => {
              this.error = response.error.reason;
            });
            rzp1.open();
            rzp1.on('payment.success', function (response: any) {
            })
          }
          else {
            this.toastr.error(data.message);
          }
        },
        err => {
          this.error = err.error.message;

        }
      );
    }
  }

  // Get All Languages  for dropdown values
  getAllLanguages() {
    this.institutionService.getAllLanguages().subscribe(res => {
      if (res.status) {
        res.data.forEach((element: any) => {
          this.language.push({
            value: element._id,
            label: element.language
          })
        })
        this.lang = this.language
        this.dropdowns = [
          {
            buttonColor: "primary",
            arr: this.lang
          }]
      }
    })
  }
}

